import { Section } from "app/models/surveyScheme/section";

export class Survey {
  public title: string;
  public number: string;
  public dateCreated: Date;
  public sections: Section[];
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/surveyScheme/survey.ts